import { ChangeDetectorRef, Component, ElementRef, HostBinding, HostListener, OnInit, OnDestroy, SimpleChanges, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { fromEvent, Subject, interval } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, tap, auditTime, takeUntil, take } from 'rxjs/operators';
import { Constant } from 'src/app/constant/constant';
import { EcryptServiceService } from 'src/app/core/auth/EcryptionService/ecrypt-service.service';
import { CommonService } from 'src/app/services/common.service';
import { WebsocketService } from 'src/app/services/websocket.service';
import { WhatsappBlockService } from 'src/app/services/whatsapp-block.service';
import { WhatsappChatService } from 'src/app/services/whatsapp-chat.service';
import { WhatsappcontactService } from 'src/app/services/whatsappcontact.service';
import { getPageSize, ResourceAccess } from 'src/app/shared/utils/calsoft-validators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Location } from '@angular/common';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { WhatsAppAssigneUserComponent } from './whats-app-assigne-user/whats-app-assigne-user.component';
import { FileLikeObject, FileUploader } from 'ng2-file-upload';
import { FileUploadService } from 'src/app/services/file-upload.service';
import { DownloadImageService } from 'src/app/services/download-image.service';
import { ImageZoomComponent } from './image-zoom/image-zoom.component';
import { environment } from 'src/environments/environment';
import { LoaderService } from 'src/app/services/loader.service';
import { MediaPickerDialogComponent } from './media-picker-dialog/media-picker-dialog.component';
import { WhatsappMessageLogsService } from 'src/app/services/whatsapp-message-logs.service';
export interface Chat {
  id: number;
  name: string;
  lastMessage: string;
  time: string;
  unread: boolean;
  isGroup: boolean;
  avatar?: string;
  messages: Message[];
}

export interface Message {
  id: number;
  text: string;
  time: string;
  sent: boolean;
  received: boolean;
  read: boolean;
  isMedia?: boolean;
  mediaUrl?: string;
}

export const CHATS: Chat[] = [
];
@Component({
  selector: 'calsoft-whatsapp-chat',
  templateUrl: './whatsapp-chat.component.html',
  styleUrls: ['./whatsapp-chat.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WhatsappChatComponent implements OnInit, OnDestroy {

  url = '';
  sanitizedUrl = '';

  private destroy$ = new Subject<void>();
  private timeouts: any[] = [];

  @HostBinding('class.fixed-header')
  fixedHeader: boolean;
  mobileView = false;
  previousWidth = 0;
  searchQuery: string = '';
  searchResults: any[] = [];
  currentMatchIndex: number = 0;
  highlightedMessageId: string | null = null;
  searchQueryTwo: string = '';
  filteredContacts: any[] = [];
  originalContacts: any[] = [];
  chats = CHATS;
  activeTab = 'all';
  chatDetails: any;
  isFavorite: boolean = false;
  currentPage = 0;
  pageSize = 10;
  isLoadingContacts = false;
  allContactsLoaded = false;
  groupedSearchResults: any[] = [];
  showSearchPanel: boolean = false;
  @ViewChild('chatListContainer', { static: false }) chatListContainer: ElementRef;
  @ViewChild('errorDialogTemplate') errorDialogTemplate: TemplateRef<any>;
  whatsapplogs: any;
  contacts: any;
  messageText: string = '';
  isSending: boolean = false;
  read: any = false;
  whatsappMessageLog: any;
  whatsappVendorId: any;
  whatsappContactId: string;
  crmSettingsData: any;
  @ViewChild('searchInput') searchInput: ElementRef;
  searchTermMain = '';
  searchTermMainPresent = false;
  searchTermMainEmit = 0;
  paramid: string;
  contactData: Object;
  canReply: boolean = true;
  showCannotReplyWarning: boolean = false;
  replyWindowClosesAt: Date | null = null;
  remainingTime: string = '';
  private timeUpdateInterval: any;
  hideinitialLoadContacts: boolean = false;
  isScrolled: boolean = false;
  showMainMeu: boolean = false;
  blockedUsers: string[] = [];
  showEmojiPicker = false;
  unreadUserMessages = 0;


  @ViewChild("myInput") myInputVariable: ElementRef;
  NotBlocked: boolean = true;
  search: any;
  spinner: boolean;
  whatsappMessageLogsService: any;
  whatsappMessageLogsList: any;
  elements: any;
  pageList: any;
  pageSizeValue: any;
  // Search pagination state
  searchPageNumber: number = 0;
  searchSize: number = Constant.SIZE;
  searchHasMore: boolean = false;
  searchTotalElements: number = 0;
  selectedSearchResultUid: string | null = null;


  private fetchingUrls: Set<string> = new Set();


  constructor(private router: Router,
    private cdRef: ChangeDetectorRef,
    private fileUploadService: FileUploadService,
    private ecryptService: EcryptServiceService,
    public websocket: WebsocketService,
    private snackBar: MatSnackBar,
    private whatsappservice: WhatsappChatService,
    private whatsappContactService: WhatsappcontactService,
    private commonService: CommonService,
    private whatsappBlockService: WhatsappBlockService,
    private dialog: MatDialog,
    private location: Location,
    private _formBuilder: UntypedFormBuilder,
    private whatsappMessageLogsServiceNew: WhatsappMessageLogsService,
    private route: ActivatedRoute,
    private loaderService: LoaderService,
    private downloadImageService: DownloadImageService) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });

    this.fixedHeader = false;
    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });


  }
  onKeyUp(event: KeyboardEvent): void {
    const isMobile = window.innerWidth <= 768; // detect mobile view

    if (event.key === 'Enter' && !event.shiftKey) {
      if (isMobile) {
        // Mobile: Insert new line instead of sending
        event.preventDefault();
        const target = event.target as HTMLTextAreaElement;
        const cursorPos = target.selectionStart;
        this.messageText =
          this.messageText.slice(0, cursorPos) + '\n' + this.messageText.slice(cursorPos);

        // Move cursor after new line
        setTimeout(() => {
          target.selectionStart = target.selectionEnd = cursorPos + 1;
        });
      } else {
        // Desktop: Send message
        event.preventDefault();
        this.sendMessage();
      }
    }
  }

  fetchBlockedUsers(): void {
    this.whatsappservice.getBlockedUsers()
      .pipe(take(1))
      .subscribe(
        (response: any) => {
          const blockedList = (response?.data || []).map((entry: any) => entry.wa_id);
          this.blockedUsers = blockedList;
          console.log('Blocked Users:', this.blockedUsers);
        },
        (error) => {
          console.error('Failed to load blocked users:', error);
          this.blockedUsers = [];
        }
      );
  }

  isContactBlocked(): boolean {
    console.log(this.selectedContact);
    return Array.isArray(this.blockedUsers) && this.blockedUsers.includes(this.selectedContact.waId);
  }

  sendMessage(): void {


    if (this.isContactBlocked()) {
      console.warn('Message not sent. Contact is blocked.');
      return;
    }

    if (!this.messageText.trim() || !this.selectedContact || this.isSending) {
      return;
    }

    if (!navigator.onLine) {
      console.warn("User is offline");
      this.snackBar.open("You're offline. Message not sent.", 'Close', {
        duration: 3000,
      });
      return;
    }

    this.loaderService.show();

    const body = {
      messageBody: this.messageText,
      contactUid: this.selectedContact.uid
    };
    this.messageText = "";
    this.whatsappservice.sendMessage(body, this.whatsappVendorId)
      .subscribe({
        next: (response) => {

          this.loaderService.hide();
          console.log('Message sent successfully:', response);
          this.messageText = '';

          this.getAllWhatssappChat();
          if (this.selectedContact?.uid) {
            // this.loadChatMessages(this.selectedContact.uid);
          }
          setTimeout(() => {
            if (this.msgInput) {
              this.adjustTextAreaHeight(this.msgInput.nativeElement);
            }
          }, 500);



          this.isSending = false;
        },
        error: (error) => {
          console.error('Error sending message:', error);
          this.loaderService.hide();
          this.isSending = false;

          // Show error message based on network or server issue
          if (!navigator.onLine) {
            this.snackBar.open("You're offline. Message not sent.", 'Close', {
              duration: 3000,
            });
          } else {
            this.snackBar.open("Failed to send message. Try again.", 'Close', {
              duration: 3000,
            });
          }

          // Optional: Add logic to mark message as "failed" in UI
        }
      });

    setTimeout(() => {
      this.checkCanReply();
    }, 500);
  }

  showErrorMessage(errorMessage: string): void {
    if (errorMessage) {
      this.dialog.open(this.errorDialogTemplate, {
        data: { errorMessage },
        width: '400px'
      });
    }
  }

  setActiveTab(tab: string): void {
    this.activeTab = tab;
    this.filterContacts();
  }
  filterContacts(): void {
    if (this.activeTab === 'all') {
      this.filteredContacts = [...this.contacts];
    } else if (this.activeTab === 'unread') {
      this.filteredContacts = this.contacts.filter(contact =>
        contact.unreadMessagesCount > 0
      );
    }
  }

  cid: string;

  ngOnInit(): void {
    this.checkMobileView();
    this.clearSearch();



    // Use RxJS fromEvent instead of addEventListener for proper cleanup
    fromEvent(window, 'resize')
      .pipe(
        debounceTime(300),
        takeUntil(this.destroy$)
      )
      .subscribe(() => this.checkMobileView());

    this.route.paramMap
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        this.paramid = params.get('contactid');
        console.log('Contact ID:', this.paramid);
      });

    // React to query param changes so browser back/forward closes or opens a chat
    this.route.queryParamMap
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        const contactUid = params.get('contact');
        if (contactUid) {
          if (this.selectedContactUid === contactUid) return;
          // Prefer an existing contact object if available
          const contactFromList = (this.contacts || []).find((c: any) => c.uid === contactUid) || (this.filteredContacts || []).find((c: any) => c.uid === contactUid);
          if (contactFromList) {
            this.onContactSelected(contactFromList);
          } else {
            // Load messages when contact object is not present yet
            this.selectedContactUid = contactUid;
            this.loadChatMessages(contactUid);
          }
        } else {
          // No contact query param -> close chat
          this.selectedContact = null;
          this.selectedContactUid = null;
          this.whatsappMessageLog = [];
          this.resetTextArea();
          try { this.cdRef.detectChanges(); } catch (_) { }
        }
      });

    if (this.paramid) {
      this.hideinitialLoadContacts = true;
      this.onManualContactSelected(this.paramid)
    }

    const encryptedContactDetails = localStorage.getItem('whatsappContactDetails');
    if (encryptedContactDetails) {
      try {
        const decryptedContactDetails = this.ecryptService.decryptionAES(encryptedContactDetails);
        const contactRow = JSON.parse(decryptedContactDetails);
        if (contactRow && contactRow.id) {
          this.hideinitialLoadContacts = true;
          this.onManualContactSelected(contactRow.id);
        }
      } catch (err) {
        console.error("Error decrypting whatsappContactDetails", err);
      }
    }

    let values = localStorage.getItem(Constant.enterPriseKey);

    this.cid = "&cid=" + values

    const encrypted = localStorage.getItem('crmSettingsData');
    if (encrypted) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encrypted);
        this.crmSettingsData = JSON.parse(decrypted);
        console.log("CRM Settings Data:", this.crmSettingsData);

        this.whatsappVendorId = this.crmSettingsData.whatsappVendorId;
        this.whatsappContactId = this.crmSettingsData.whatsappContactId;
      } catch (err) {
        console.error("Error decrypting crmSettingsData", err);
      }
    }

    //get vendor id and contact id
    this.whatsappservice.getVendorId()
      .pipe(take(1))
      .subscribe(
        (response: any) => {
          if (response) {
            this.whatsappVendorId = response.vendorId;
            this.whatsappContactId = response.contactId;

            this.getResource();

            this.getMainResource();

            if (this.whatsappVendorId) {
              this.websocket.connect(this.whatsappVendorId);
              this.websocket.message$
                .pipe(takeUntil(this.destroy$))
                .subscribe((message: any) => {
                  console.log("the message is", message);

                  if (message.type === 'read' && message.messageId) {
                    // Find the message inside whatsappMessageLog and mark it read
                    const foundMsg = this.whatsappMessageLog.find((m: any) => m.uid === message.messageId);
                    if (foundMsg) {
                      foundMsg.status = 'read';
                    }
                  } else {
                    this.currentPage = 0;
                    this.getAllWhatssappChat();
                    this.filterContacts();
                  }
                });
            }
          }
        },
        (error) => {
          console.error('Error fetching vendor and contact id:', error);
        }
      );



    this.fetchBlockedUsers();

    // Ensure local spinner follows the global LoaderService state
    this.loaderService.isLoading
      .pipe(takeUntil(this.destroy$))
      .subscribe((loading: boolean) => {
        this.spinner = !!loading;
        try { this.cdRef.detectChanges(); } catch (_) { }
      });

  }

  focusMessageInput(): void {
    setTimeout(() => {
      if (this.msgInput && this.msgInput.nativeElement) {
        this.msgInput.nativeElement.focus();
      }
    }, 100);
  }




  sendTemplateMessage(row: any) {

    localStorage.removeItem('whatsappContactDetails')
    if (row) {
      const whatsappContactDetails = this.ecryptService.encryptionAES(JSON.stringify(row));
      localStorage.setItem('whatsappContactDetails', whatsappContactDetails);
      this.router.navigate([`/whatsAppContact/sendtemplate/${row.id}`])
    }
  }


  selectedContact: any = null;
  selectedContactUid: string | null = null;
  onContactSelected(contact: any): void {
    // Reduce unread count locally
    contact.unreadMessagesCount = 0;
    contact.lastUnreadMessage = null;

    this.selectedContact = contact;
    this.selectedContactUid = contact.uid;
    // Close any open search panel and clear search state
    this.showSearchPanel = false;
    this.searchQuery = '';
    this.selectedSearchResultUid = null;
    this.highlightedMessageId = null;
    // show spinner while loading chat
    this.spinner = true;
    try { this.loaderService.show(); } catch (_) { }
    this.loadChatMessages(contact.uid);
    //To clear the chat when switched
    this.messageText = "";
    this.resetTextArea();
    this.updateContactInList(contact.uid);
    this.filterContacts();
    this.focusMessageInput();

    // 👉 Update the URL with the selectedContactUid
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { contact: contact.uid },
      queryParamsHandling: 'merge', // keeps existing query params
    });
  }


  onManualContactSelected(id: any): void {

    this.fetchContactData(id, this.whatsappVendorId);
    this.focusMessageInput();
    this.resetTextArea();
  }


  fetchContactData(id: number, vendorId?: any): void {
    this.whatsappContactService.getWhatsappContactDataById(id)
      .pipe(take(1))
      .subscribe({
        next: (data) => {
          this.contactData = data;
          this.selectedContact = this.contactData
          console.log("the selected data ", this.selectedContact);
          this.selectedContact.unreadMessagesCount = 0;
          this.selectedContact.lastUnreadMessage = null;
          this.selectedContactUid = this.selectedContact.contactUid;
          this.loadChatMessages(this.selectedContactUid);
          this.clearContactSearch();
          this.resetTextArea();
          console.log('Contact Data:', data);
        },
        error: (err) => {
          console.error('Error fetching contact data', err);
        }
      });
  }
  updateContactInList(contactUid: string): void {
    const contactIndex = this.contacts.findIndex(c => c.uid === contactUid);
    if (contactIndex !== -1) {
      this.contacts[contactIndex].unreadMessagesCount = 0;
      this.contacts[contactIndex].lastUnreadMessage = null;
    }

    const filteredIndex = this.filteredContacts.findIndex(c => c.uid === contactUid);
    if (filteredIndex !== -1) {
      this.filteredContacts[filteredIndex].unreadMessagesCount = 0;
      this.filteredContacts[filteredIndex].lastUnreadMessage = null;
    }
  }

  isBlocked: any = 0;

  public page: any = Constant.PAGE;
  public size: any = Constant.SIZE;
  sortParam: any = 'id' + "," + Constant.Dsc;

  loadChatMessages(contactUid: string): void {
    if (this.whatsappVendorId != undefined) {
      this.spinner = true;
      try { this.loaderService.show(); } catch (_) { }
      // Reset pagination for message history when loading a new contact
      this.pageMsg = 0;
      this.hasMoreMessages = true;
      this.isLoadingMoreMsg = false;

      this.whatsappservice.getAllWhatsAppChat(contactUid, this.page, this.size, this.sortParam)
        .pipe(take(1))
        .subscribe({
          next: (data: any) => {
            if (data && data.chatData && data.chatData.contactDetails && data.chatData.contactDetails.length > 0) {
              this.chatDetails = data.chatData.contactDetails[0];

              this.isBlocked = 0;
              if (this.chatDetails.isBlocked != undefined) {
                this.isBlocked = this.chatDetails.isBlocked;
              }

              // unread handle
              if (this.chatDetails.lastUnreadMessageCount > 0) {
                if (this.unreadUserMessages > 0) {
                  this.unreadUserMessages--;
                }
              }

              // Process messages if present
              if (this.chatDetails.whatsappMessageLog && this.chatDetails.whatsappMessageLog.length) {
                const processed = this.chatDetails.whatsappMessageLog.map((msg: any) => {
                  if (msg.data) {
                    try {
                      const parsed = JSON.parse(msg.data);
                      if (parsed.interaction_message_data) {
                        const interactiveData = parsed.interaction_message_data;
                        msg.interactiveType = interactiveData.interactive_type;
                        msg.interactiveData = {
                          headerType: interactiveData.header_type,
                          mediaLink: interactiveData.media_link,
                          bodyText: interactiveData.body_text,
                          footerText: interactiveData.footer_text,
                          headerText: interactiveData.header_text,
                          buttons: interactiveData.buttons,
                          listData: interactiveData.list_data,
                          ctaData: interactiveData.cta_url
                        };
                        if (interactiveData.header_type && ['image', 'video', 'audio', 'document'].includes(interactiveData.header_type)) {
                          msg.media = { mediaUrl: interactiveData.media_link, extension: this.getFileExtension(interactiveData.media_link) };
                        }
                        switch (msg.interactiveType) {
                          case 'button':
                            msg.buttonData = { buttons: interactiveData.buttons, bodyText: interactiveData.body_text, footerText: interactiveData.footer_text, headerText: interactiveData.header_text, headerType: interactiveData.header_type, mediaLink: interactiveData.media_link };
                            break;
                          case 'list':
                            msg.listData = { buttonText: interactiveData.list_data?.button_text, sections: this.parseSections(interactiveData.list_data?.sections), bodyText: interactiveData.body_text, footerText: interactiveData.footer_text, headerText: interactiveData.header_text };
                            break;
                          case 'cta_url':
                            msg.ctaData = { displayText: interactiveData.cta_url?.display_text, url: interactiveData.cta_url?.url, bodyText: interactiveData.body_text, footerText: interactiveData.footer_text, headerText: interactiveData.header_text };
                            break;
                        }
                      }

                      if (parsed.template_proforma) {
                        const template = parsed.template_proforma;
                        const components = template.components || [];
                        msg.templateComponents = {};
                        components.forEach((comp: any) => {
                          switch (comp.type) {
                            case 'HEADER': msg.templateComponents.header = { type: comp.format?.toLowerCase() || 'text', text: comp.text || '', example: comp.example?.header_handle?.[0] || '' }; break;
                            case 'BODY': msg.templateComponents.body = comp.text || ''; break;
                            case 'FOOTER': msg.templateComponents.footer = comp.text || ''; break;
                            case 'BUTTONS': msg.templateComponents.buttons = comp.buttons || []; break;
                          }
                        });
                        if (parsed.template_components) {
                          parsed.template_components.forEach((comp: any) => {
                            switch (comp.type) {
                              case 'HEADER': msg.templateComponents.header = { type: comp.format?.toLowerCase() || 'text', text: comp.text || '', example: comp.example?.header_handle?.[0] || '', url: msg.templateComponents.header?.url || '' }; break;
                              case 'BODY': msg.templateComponents.body = comp.text || ''; break;
                              case 'FOOTER': msg.templateComponents.footer = comp.text || ''; break;
                              case 'BUTTONS': msg.templateComponents.buttons = comp.buttons || []; break;
                            }
                          });
                        }
                        if (parsed.template_component_values) {
                          parsed.template_component_values.forEach((compVal: any) => {
                            if (compVal.type === 'header' && compVal.parameters?.length) {
                              const param = compVal.parameters[0];
                              if (param.type === 'location') {
                                msg.templateComponents = msg.templateComponents || {};
                                msg.templateComponents.location = { name: param.location?.name || '', address: param.location?.address || '', latitude: param.location?.latitude || '', longitude: param.location?.longitude || '' };
                              }
                              if (msg.templateComponents.header) {
                                const link = param.image?.link || param.video?.link || param.document?.link;
                                if (link) {
                                  const urlObj = new URL(link);
                                  urlObj.searchParams.delete('cid');
                                  msg.templateComponents.header.url = decodeURIComponent(urlObj.toString());
                                } else if (param.text) {
                                  msg.templateComponents.header.text = param.text;
                                }
                              }
                            }
                            if (compVal.type === 'body' && compVal.parameters?.length) {
                              parsed.template_components?.forEach((comp: any) => {
                                if (comp.type === 'BODY' && comp.text) {
                                  let bodyText = comp.text.replace(/&#123;/g, '{').replace(/&#125;/g, '}');
                                  const bodyCompVal = parsed.template_component_values?.find((v: any) => v.type?.toLowerCase() === 'body');
                                  if (bodyCompVal?.parameters?.length) {
                                    bodyCompVal.parameters.forEach((p: any, i: number) => {
                                      if (p.type === 'text' && p.text) { bodyText = bodyText.replace(new RegExp(`{{\\s*${i + 1}\\s*}}`, 'g'), p.text.trim()); }
                                    });
                                  }
                                  msg.templateComponents = msg.templateComponents || {};
                                  msg.templateComponents.body = bodyText;
                                }
                              });
                            }
                          });
                        }
                      }

                      if (parsed.webhook_responses && msg?.message === '' && !msg?.interactiveType?.length) {
                        try { const webHookText = parsed.webhook_responses.incoming[0].changes[0].value.messages[0].text.body; msg.WebHookText = webHookText; } catch (_) { }
                      }

                      const media = parsed.media_values;
                      let mediaUrl = media?.link;
                      let mediaType = media?.type;
                      let mediaMimeType = media?.mime_type;
                      let mediaCaption = media?.caption || '';
                      let mediaFilename = media?.file_name || '';

                      if (!mediaUrl && parsed.webhook_responses?.incoming?.[0]?.changes?.[0]?.value?.messages?.[0]) {
                        const whMsg = parsed.webhook_responses.incoming[0].changes[0].value.messages[0];
                        const whType = whMsg.type;
                        if (whType && whMsg[whType]) {
                          mediaUrl = whMsg[whType].url;
                          mediaType = whType;
                          mediaMimeType = whMsg[whType].mime_type;
                          mediaCaption = whMsg[whType].caption || '';
                          mediaFilename = whMsg[whType].filename || '';
                        }
                      }

                      if (mediaUrl && (mediaType || mediaMimeType)) {
                        let type = mediaType;
                        if ((type === 'document' || !type) && mediaMimeType) {
                          const mimeMain = mediaMimeType.split('/')[0];
                          if (['image', 'video', 'audio'].includes(mimeMain)) { type = mimeMain; }
                        }
                        msg.mediaData = { type, url: mediaUrl.trim(), caption: mediaCaption || '', mimeType: mediaMimeType || '' };
                        let extMatch = (mediaFilename || '').match(/\.([a-zA-Z0-9]+)(?=[?#]|$)/);
                        if (!extMatch) {
                          extMatch = mediaUrl.match(/\.([a-zA-Z0-9]+)(?=[?#]|$)/);
                        }
                        msg.mediaData.extension = extMatch ? extMatch[1].toLowerCase() : '';
                        if (!msg.mediaData.extension && mediaMimeType) {
                          const parts = mediaMimeType.split('/');
                          if (parts.length > 1) {
                            let ext = parts[1].toLowerCase();
                            if (ext === 'plain') ext = 'txt';
                            if (ext === 'mpeg') ext = 'mp3';
                            msg.mediaData.extension = ext;
                          }
                        }
                      } else { msg.mediaData = null; }
                    } catch (e) { console.error('Error parsing message data', e); }
                  }
                  return msg;
                });

                // Reverse the DESC-sorted messages to show them chronologically (oldest to newest)
                this.whatsappMessageLog = processed.reverse();
              } else {
                this.whatsappMessageLog = [];
              }
              // If we received contact details from the server and there's no selectedContact object,
              // use the returned contact details so the header shows correctly when opened via URL.
              if (!this.selectedContact && this.chatDetails) {
                try {
                  this.selectedContact = this.chatDetails;
                  // Ensure selectedContactUid is in sync
                  if (this.chatDetails && this.chatDetails.contactUid) {
                    this.selectedContactUid = this.chatDetails.contactUid;
                  }
                } catch (_) { }
              }
            } else {
              this.whatsappMessageLog = [];
            }

            this.checkCanReply();
            setTimeout(() => {
              if (this.messagesContainer) {
                const el = this.messagesContainer.nativeElement;
                el.scrollTop = el.scrollHeight; // Instant, no animation
              }
            }, 0);

            this.focusMessageInput();
            this.showMainMeu = true;
            if (this.showMainMeu == true && this.mobileView) {
              localStorage.setItem('HideMainMenu', 'true');
            }
            try { this.loaderService.hide(); } catch (_) { }
          },
          error: (err: any) => {
            console.error('Error loading chat messages', err);
            this.whatsappMessageLog = [];
            this.spinner = false;
            try { this.loaderService.hide(); } catch (_) { }
          },
          complete: () => {
            this.spinner = false;
            try { this.loaderService.hide(); } catch (_) { }
          }
        });
    } else {
      this.whatsappMessageLog = [];
    }
  }

  private mediaUrlCache = new Map<string, string>();


  /**
  * Returns a cached blob URL for the given media URL.
  *
  * On the first call for a given URL:
  *  - Returns '' (no broken-image flicker because Angular only updates when
  *    cdRef.markForCheck() is called after the fetch completes)
  *  - Kicks off a single background HTTP request via the service
  *  - On success stores the blob URL in the cache and triggers change detection
  *
  * Subsequent calls for the same URL return the cached value immediately.
  * Non-lookaside URLs are returned as-is (append cid cookie as before).
  */
  getMediaUrl(url: string): string {
    if (!url) return '';

    if (
      url.includes('lookaside.fbsbx.com') ||
      url.includes('fbsbx.com') ||
      url.includes('whatsapp_business/attachments') ||
      url.includes('scontent.whatsapp.net') ||
      url.includes('fbcdn.net')
    ) {
      // Return cached blob URL if we already fetched it
      if (this.mediaUrlCache.has(url)) {
        return this.mediaUrlCache.get(url)!;
      }

      // Kick off a single fetch if not already in-progress
      if (!this.fetchingUrls.has(url)) {
        this.fetchingUrls.add(url);
        this.whatsappservice.getImageByUrl(url).subscribe({
          next: (blobUrl: string) => {
            this.mediaUrlCache.set(url, blobUrl);
            this.fetchingUrls.delete(url);
            this.cdRef.markForCheck();
          },
          error: () => {
            this.fetchingUrls.delete(url);
          }
        });
      }

      // Return empty while the request is in-flight
      return '';
    }

    // Non-CDN URLs: append cid cookie as before
    const cidValue = localStorage.getItem(Constant.enterPriseKey) || '';
    return url + (cidValue ? '&cid=' + cidValue : '');
  }

  private getFileExtension(url: string): string {
    if (!url) return '';
    const match = url.match(/\.([a-zA-Z0-9]+)(?=[?#]|$)/);
    return match ? match[1].toLowerCase() : '';
  }



  getButtons(buttonsObj: any): string[] {
    if (!buttonsObj) return [];
    return Object.values(buttonsObj);
  }


  @ViewChild('msgInput') msgInput: ElementRef<HTMLTextAreaElement>;
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['this.selectedContact']) {
      this.resetTextArea();
    }
  }

  resetTextArea(): void {
    this.messageText = '';
    this.isLimitExceeded = false;
    this.showCharLimitPopup = false;

    const textAreaEl = this.msgInput?.nativeElement;
    if (textAreaEl) {
      textAreaEl.style.height = 'auto';
      textAreaEl.style.height = '50px';
    }
  }
  isLimitExceeded: boolean = false;
  maxCharLimit = 3999;
  showCharLimitPopup = false;
  @ViewChild('inputContainer') inputContainer!: ElementRef;
  inputHeight: number = 60;
  adjustTextAreaHeight(textarea?: HTMLTextAreaElement): void {
    textarea.style.height = 'auto';
    textarea.style.height = textarea.scrollHeight + 'px';

    setTimeout(() => {
      if (this.inputContainer) {
        this.inputHeight = this.inputContainer.nativeElement.offsetHeight;
      }
    });
    const textAreaEl = textarea || this.msgInput?.nativeElement;
    if (!textAreaEl) return;

    // Trim text if exceeds limit
    if (textAreaEl.value.length > this.maxCharLimit) {
      this.isLimitExceeded = true;
      this.showCharLimitPopup = true;

      // Trim to max limit
      textAreaEl.value = textAreaEl.value.substring(0, this.maxCharLimit);
      this.messageText = textAreaEl.value;

      // Auto-hide popup after 3 seconds
      setTimeout(() => this.showCharLimitPopup = false, 3000);
    } else {
      this.isLimitExceeded = false;
      this.showCharLimitPopup = false;
    }

    // Adjust height
    textAreaEl.style.height = 'auto';
    textAreaEl.style.height = textAreaEl.scrollHeight + 'px';
  }
  sendInParts(): void {
    if (!this.messageText.trim()) return;

    const messages = [];
    let remainingText = this.messageText;

    while (remainingText.length > 0) {
      const part = remainingText.substring(0, this.maxCharLimit);
      messages.push(part);
      remainingText = remainingText.substring(this.maxCharLimit);
    }

    messages.forEach((part, index) => {
      setTimeout(() => {
        this.messageText = part;
        this.sendMessage();
      }, index * 500);
    });

    this.messageText = '';
    this.resetTextArea();
  }

  getMediaData(message: any): { type: string, url: string, caption?: string } | null {
    try {
      if (message.data) {
        const parsed = JSON.parse(message.data);
        if (parsed.media_values && parsed.media_values.link && parsed.media_values.type) {
          return {
            type: parsed.media_values.type,
            url: parsed.media_values.link,
            caption: parsed.media_values.caption || ''
          };
        }
      }
    } catch (e) {
      console.error('Failed to parse media data', e);
    }
    return null;
  }
  parseSections(sectionsObj: any): any[] {
    if (!sectionsObj) return [];
    return Object.values(sectionsObj).map((section: any) => ({
      title: section.title,
      rows: section.rows ? Object.values(section.rows) : []
    }));
  }
  checkCanReply(): void {
    if (!this.whatsappMessageLog || this.whatsappMessageLog.length === 0) {
      this.canReply = true;
      this.showCannotReplyWarning = false;
      this.replyWindowClosesAt = null;
      this.remainingTime = '';
      return;
    }

    const lastMessage = this.whatsappMessageLog[this.whatsappMessageLog.length - 1];
    const lastMessageTime = new Date(lastMessage.messagedAt).getTime();
    const now = new Date().getTime();
    const twentyFourHours = 24 * 60 * 60 * 1000;

    // if (lastMessage.isIncomingMessage === 0) {
    //   this.canReply = true;
    //   this.showCannotReplyWarning = false;
    //   this.replyWindowClosesAt = null;
    //   this.remainingTime = '';
    //   return;
    // }


    const timeSinceLastMessage = now - lastMessageTime;
    this.canReply = timeSinceLastMessage <= twentyFourHours;
    this.showCannotReplyWarning = !this.canReply;
    if (this.isBlocked === 1) {

      this.NotBlocked = false;

    }
    else {
      this.NotBlocked = true
    }


    if (this.canReply) {
      this.replyWindowClosesAt = new Date(lastMessageTime + twentyFourHours);
      this.updateRemainingTime();

      if (this.timeUpdateInterval) {
        clearInterval(this.timeUpdateInterval);
        this.timeUpdateInterval = null;
      }
      // Use RxJS interval instead of setInterval for automatic cleanup
      interval(60000)
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => {
          if (this.replyWindowClosesAt) {
            this.updateRemainingTime();
          }
        });
    } else {
      this.replyWindowClosesAt = null;
      this.remainingTime = '';
      if (this.timeUpdateInterval) {
        clearInterval(this.timeUpdateInterval);
        this.timeUpdateInterval = null;
      }
    }
  }
  updateRemainingTime(): void {
    if (!this.replyWindowClosesAt) return;

    const now = new Date();
    const diff = this.replyWindowClosesAt.getTime() - now.getTime();

    if (diff <= 0) {
      this.canReply = false;
      this.showCannotReplyWarning = true;
      this.remainingTime = '';
      return;
    }

    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

    this.remainingTime = `${hours} hours and ${minutes} minutes`;
  }

  sort = 'createdAt,desc';
  resourcePrivilege: any;
  getMainResource() {
    this.commonService
      .getAllAccessForResource(ResourceAccess.WHATSAPPCHAT)
      .pipe(take(1))
      .subscribe((data: any) => {
        if (!data.read) {
          this.router.navigate(['/unauthorized']);
        } else {
          this.read = data.read;
          this.resourcePrivilege = data;
          // this.getProductQtyAndExpiryAlertsReport();

        }
      });
  }

  getResource() {
    // Force reset — always allow initial/reload, even if observer fired early
    this.currentPage = 0;
    this.allContactsLoaded = false;
    this.isLoadingContacts = true;

    this.getAllWhatssappChat();
  }
  getAllWhatssappChatTwo() {
    this.currentPage = 0;
    if (this.whatsappContactId != undefined && this.whatsappVendorId != undefined) {
      this.whatsappservice.getContactsData(this.currentPage, this.pageSize, this.sort, this.whatsappContactId)
        .subscribe((response: any) => {
          console.log("websocket called");

          const newContacts = response.contacts || [];
          if (this.currentPage === 0) {
            this.contacts = newContacts;
          } else {
            // Merge and dedupe by uid to avoid duplicate entries
            const merged = [...this.contacts, ...newContacts];
            const map = new Map<string, any>();

            this.contacts = merged;
          }
          // Recompute filteredContacts from updated contacts
          this.filterContacts();
          this.allContactsLoaded = response.nextPage === 0;
          if (!this.allContactsLoaded && typeof response.nextPage !== 'undefined') {
            this.currentPage = response.nextPage;
          }

          this.isLoadingContacts = false;
        }, (error: any) => {
          console.error('Error loading contacts:', error);
          this.isLoadingContacts = false;
        });
    }
  }

  getAllWhatssappChat() {
    this.unreadUserMessages = 0;
    if (this.whatsappContactId != undefined && this.whatsappVendorId != undefined) {
      this.whatsappservice.getContactsData(this.currentPage, this.pageSize, this.sort, this.whatsappContactId)
        .subscribe((response: any) => {
          const newContacts = response.contacts || [];

          if (this.currentPage === 0) {
            this.contacts = newContacts;
          } else {
            // Append only new contacts (avoid full replacement to prevent list re-render)
            const existingUids = new Set(this.contacts.map((c: any) => c.uid));
            const toAppend = newContacts.filter((c: any) => c && c.uid && !existingUids.has(c.uid));

            if (toAppend.length > 0) {
              this.contacts.push(...toAppend);

              // Trigger change detection and recompute filtered list
              try {
                this.cdRef.detectChanges();
              } catch (e) {
                // ignore
              }
            }
          }
          // Recompute filteredContacts from updated contacts
          this.filterContacts();
          this.allContactsLoaded = response.nextPage === 0;
          if (!this.allContactsLoaded && typeof response.nextPage !== 'undefined') {
            this.currentPage = response.nextPage;
          }

          this.isLoadingContacts = false;
          if (this.isScrolled == false) {

            const urlParams = new URLSearchParams(window.location.search);
            const contactIdFromUrl = urlParams.get('contact');

            if (contactIdFromUrl) {
              this.selectedContactUid = contactIdFromUrl;
              this.loadChatMessages(contactIdFromUrl);

              if (this.filteredContacts) {
                const contactFromUrl = this.filteredContacts.find(contact => contact.uid === contactIdFromUrl);
                if (contactFromUrl) {
                  this.selectedContact = contactFromUrl;
                }
              }
            }

          }
          this.unreadUserMessages = this.filteredContacts.filter(
            contact => contact.unreadMessagesCount > 0
          ).length;
        }, (error: any) => {
          console.error('Error loading contacts:', error);
          this.isLoadingContacts = false;
        }, () => {
          this.isScrolled = false;
          this.filterContacts();
        });
    }
  }

  formatDate(dateString: string): string {
    if (!dateString) return '';

    const date = new Date(dateString);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  }

  getTemplateBody(message: any): string | null {
    if (!message.data) return null;

    try {
      const data = JSON.parse(message.data);
      if (data.template_proforma?.components) {
        const bodyComponent = data.template_proforma.components.find(
          (c: any) => c.type === 'BODY'
        );
        return bodyComponent?.text || null;
      }
      return null;
    } catch (e) {
      console.error('Error parsing message data', e);
      return null;
    }
  }

  formatMessageTime(timestamp: string): string {
    if (!timestamp) return '';

    const utcDate = new Date(timestamp);

    // Convert to IST
    const istOffsetMs = 5.5 * 60 * 60 * 1000;
    const istDate = new Date(utcDate.getTime());

    // Get parts
    const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];

    const day = istDate.getDate();
    const daySuffix = this.getDaySuffix(day);
    const weekday = weekdays[istDate.getDay()];
    const month = months[istDate.getMonth()];
    const year = istDate.getFullYear();

    let hours = istDate.getHours();
    const minutes = istDate.getMinutes().toString().padStart(2, '0');
    const seconds = istDate.getSeconds().toString().padStart(2, '0');

    const period = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12 || 12;

    return `${weekday} ${day}${daySuffix} ${month} ${year} ${hours}:${minutes}:${seconds} ${period}`;
  }
  getDaySuffix(day: number): string {
    if (day >= 11 && day <= 13) return 'th';
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }

  public uploader: FileUploader = new FileUploader({
    isHTML5: true,
    allowedFileType: ['image', 'video', 'txt', 'doc', 'pdf', 'xls', 'xlsx', 'docx']
  });


  selectMedia(type: string) {
    console.log('Selected:', type);

    const dialogRef = this.dialog.open(MediaPickerDialogComponent, {
      width: '600px',
      position: { top: '50px' },
      panelClass: 'custom-dialog-panel',
      data: { selectedType: type }
    });

    dialogRef.afterClosed()
      .pipe(take(1))
      .subscribe(result => {
        if (result) {
          console.log('Received from dialog:', result);
          this.handleUploadedFile(result);
        }
      });
  }




  openMediaPicker() {
    const dialogRef = this.dialog.open(MediaPickerDialogComponent, {
      width: '600px',
      position: { top: '50px' },
      panelClass: 'custom-dialog-panel',
    });

    dialogRef.afterClosed()
      .pipe(take(1))
      .subscribe(result => {
        if (result) {
          console.log('Received from dialog:', result);

          this.handleUploadedFile(result);
        }
      });

  }
  handleMediaUpload(event: any): void {
    const file = event.target.files[0];
    if (!file || !this.selectedContact) return;

    event.target.value = '';


    const mediaType = this.getMediaType(file.type);

    this.isSending = true;

    this.whatsappservice.sendMedia(file)
      .pipe(take(1))
      .subscribe({
        next: (uploadResponse) => {
          const body = {
            contactUid: this.selectedContact.uid,
            mediaType: mediaType,
            // uploadedMediaFileName: uploadResponse.fileName 
          };

          this.sendMediaMessage(body);
        },
        error: (error) => {
          console.error('Error uploading media:', error);
          this.isSending = false;
        }
      });
  }
  showScrollButton = false;
  @ViewChild('messagesContainer') private messagesContainer!: ElementRef;
  @ViewChild('contactsSentinel') private contactsSentinel!: ElementRef;
  private contactsObserver: IntersectionObserver | null = null;

  ngAfterViewInit() {
    this.setupContactsInfiniteScroll();
    this.setupSearch();
  }

  setupContactsInfiniteScroll() {
    // Use IntersectionObserver on a sentinel element at the bottom of the contact list.
    // This is equivalent to ngx-infinite-scroll and fires smoothly without scroll-event jank.
    if (!this.contactsSentinel) return;

    this.contactsObserver = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        // entry.isIntersecting fires on initial mount too — the guards in
        // loadMoreContacts() ensure we only act after the first page is ready
        if (entry.isIntersecting) {
          this.loadMoreContacts();
        }
      },
      {
        root: this.chatListContainer?.nativeElement ?? null, // scroll container
        threshold: 0.1   // trigger when even 10% of sentinel is visible
      }
    );

    this.contactsObserver.observe(this.contactsSentinel.nativeElement);

    // Tear down when component is destroyed
    this.destroy$.subscribe(() => {
      this.contactsObserver?.disconnect();
      this.contactsObserver = null;
    });
  }

  setupSearch() {
    fromEvent(this.searchInput.nativeElement, 'keyup').pipe(
      filter((e: any) => e.key !== 'Tab'), // ignore tab key
      debounceTime(400),
      distinctUntilChanged(),
      takeUntil(this.destroy$),
      tap(() => {
        let value = this.searchInput.nativeElement.value;

        // Handle spaces and backspace
        if (value === ' ') {
          this.searchInput.nativeElement.value = '';
          return;
        }

        value = value.trim();

        if (value.length > 0) {
          this.searchTermMainPresent = false;
          this.searchTermMain = value;
          this.searchContacts(value);
        } else {
          this.clearContactSearch();
        }
      })
    ).subscribe();
  }
  searchContacts(searchTerm: string) {
    if (!searchTerm.trim()) {
      this.clearContactSearch();
      return;
    }
    if (this.whatsappContactId === undefined || this.whatsappVendorId === undefined) return;

    this.currentPage = 0;

    this.isLoadingContacts = true;

    this.whatsappservice.getContactsDataWithSearch(
      this.currentPage,
      this.pageSize,
      this.sort,
      this.whatsappContactId,
      this.whatsappVendorId,
      searchTerm
    ).subscribe({
      next: (response) => {
        this.contacts = response.contacts || [];
        this.filteredContacts = [...this.contacts];
        this.allContactsLoaded = response.nextPage === 0;

        if (!this.allContactsLoaded) {
          this.currentPage = response.nextPage;
        }

        this.isLoadingContacts = false;
      },
      error: (error) => {
        console.error('Error searching contacts:', error);
        this.isLoadingContacts = false;
      }
    });
    this.filterContacts();
  }
  onContactSearchInput() {
    if (!this.searchQueryTwo) {
      this.clearContactSearch();
    }
  }

  ngOnDestroy() {
    // Cleanup subscriptions (includes resize, route, websocket, search)
    this.destroy$.next();
    this.destroy$.complete();

    // Clear timeouts
    this.timeouts.forEach(id => clearTimeout(id));
    this.timeouts = [];

    // Clear intervals
    if (this.timeUpdateInterval) {
      clearInterval(this.timeUpdateInterval);
      this.timeUpdateInterval = null;
    }

    // Disconnect websocket
    if (this.websocket) {
      this.websocket.disconnect();
    }

    // Cleanup
    localStorage.removeItem('HideMainMenu');
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  checkMobileView() {
    const width = window.innerWidth;
    if (width !== this.previousWidth) {
      this.mobileView = width <= 768;
      this.previousWidth = width;

      // Reset view on desktop
      if (!this.mobileView) {
        this.selectedContact = null;
        localStorage.removeItem("HideMainMenu")
      }
      if (this.showMainMeu == true && this.mobileView && this.selectedContact) {
        let str = "true";
        localStorage.setItem("HideMainMenu", str);
      }
      if (this.mobileView && this.selectedContact == null) {
        localStorage.removeItem("HideMainMenu")
      }
    }
  }

  // trackBy for contacts list to avoid full re-render and preserve scroll
  trackByUid(index: number, item: any) {
    return item ? item.uid : index;
  }


  @HostListener('scroll', ['$event'])
  onScroll(event: any) {
    // this.checkScrollPosition();
  }
  loadMoreContacts(): void {
    // Guard: only load more after initial page is loaded and vendorId is available
    if (!this.whatsappContactId || !this.whatsappVendorId) return;
    if (!this.contacts?.length) return;  // initial load not done yet
    if (this.isLoadingContacts || this.allContactsLoaded) return;

    // currentPage is already advanced by getAllWhatssappChat() via response.nextPage
    this.isScrolled = true;
    this.isLoadingContacts = true;
    this.getAllWhatssappChat();
  }

  isLoadingMoreMsg = false;
  hasMoreMessages = true;
  pageMsg = 0;

  checkScrollPosition() {
    if (this.messagesContainer) {
      const element = this.messagesContainer.nativeElement;
      const atBottom = element.scrollHeight - element.scrollTop <= element.clientHeight + 50;
      this.showScrollButton = !atBottom;

      // If user scrolled to the top (or near top), load older messages
      const nearTopThreshold = 60; // px
      if (element.scrollTop <= nearTopThreshold && !this.isLoadingMoreMsg && this.hasMoreMessages) {
        this.loadOlderMessages();
      }
    }
  }

  /**
   * Load older messages for the selected contact using contact numeric ID.
   * Calls GET /api/whatsapp/chat-history/{contactId}?page=X&size=Y
   * Spring Page response: { content: [], last: boolean, number: int, totalElements: int }
   */
  loadOlderMessages(): void {
    if (!this.selectedContact?.id || this.isLoadingMoreMsg || !this.hasMoreMessages) return;

    this.isLoadingMoreMsg = true;
    const nextPage = this.pageMsg + 1;

    const element = this.messagesContainer?.nativeElement;
    const previousScrollHeight = element ? element.scrollHeight : 0;

    this.whatsappservice.getChatHistoryByContactId(
      this.selectedContact.id,
      nextPage,
      this.size
    ).subscribe((data: any) => {
      const rawMessages: any[] = data?.content || [];
      const isLastPage: boolean = data?.last ?? true;

      if (rawMessages.length === 0) {
        this.hasMoreMessages = false;
        this.isLoadingMoreMsg = false;
        return;
      }

      // API returns DESC order — reverse so oldest appears at top when prepended
      const newMessages = [...rawMessages].reverse();

      // ── Full message-parsing pipeline (mirrors loadChatMessages) ──────────────
      const processed = this.processRawMessages(newMessages);
      // ─────────────────────────────────────────────────────────────────────────

      // ─────────────────────────────────────────────────────────────────────────

      // Deduplicate against already-displayed messages
      const existingIds = new Set(this.whatsappMessageLog.map((m: any) => m.uid));
      const toAdd = processed.filter((m: any) => !existingIds.has(m.uid));

      if (toAdd.length > 0) {
        // Prepend older messages
        this.whatsappMessageLog = [...toAdd, ...this.whatsappMessageLog];
        this.pageMsg = nextPage;

        // Restore scroll so viewport doesn't jump to the top
        setTimeout(() => {
          if (element) {
            element.scrollTop = element.scrollHeight - previousScrollHeight;
          }
          this.isLoadingMoreMsg = false;
        }, 0);
      } else {
        // All returned messages were duplicates — no more pages
        this.hasMoreMessages = false;
        this.isLoadingMoreMsg = false;
      }

      if (isLastPage) {
        this.hasMoreMessages = false;
      }
    }, () => {
      this.isLoadingMoreMsg = false;
    });
  }

  scrollToBottom(): void {
    try {
      if (this.messagesContainer) {
        this.messagesContainer.nativeElement.scroll({
          top: this.messagesContainer.nativeElement.scrollHeight,
          behavior: 'smooth'
        });
      }
    } catch (err) {
      console.error(err);
    }
  }
  getMediaType(mimeType: string): string {
    if (mimeType.startsWith('image/')) {
      return 'IMAGE';
    } else if (mimeType.startsWith('video/')) {
      return 'VIDEO';
    } else if (mimeType.startsWith('audio/')) {
      return 'AUDIO';
    } else if (mimeType === 'application/pdf') {
      return 'DOCUMENT';
    } else if (
      mimeType === 'application/msword' ||
      mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ) {
      return 'DOCUMENT';
    } else if (
      mimeType === 'application/vnd.ms-excel' ||
      mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ) {
      return 'DOCUMENT';
    } else if (
      mimeType === 'application/vnd.ms-powerpoint' ||
      mimeType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
    ) {
      return 'DOCUMENT';
    } else {
      return 'DOCUMENT'; // default to document for other file types
    }
  }

  sendMediaMessage(body: any): void {
    this.whatsappservice.sendMedia(body)
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          console.log('Media message sent successfully:', response);
          if (this.selectedContact?.uid) {
            this.loadChatMessages(this.selectedContact.uid);
          }
        },
        error: (error) => {
          console.error('Error sending media message:', error);
        },
        complete: () => {
          this.isSending = false;
        }
      });
  }
  onSearch(): void {
    if (!this.searchQuery.trim()) {
      this.clearSearch();
      return;
    }

    const query = this.searchQuery.toLowerCase();


    this.page = Constant.PAGE;
    this.size = Constant.SIZE;
    let searchTerm = "message:'" + '*' + query.trim() + '*'
      + "'  AND contactId:" + this.selectedContact.id + ","

    // start fresh search (reset pagination)
    this.searchPageNumber = Constant.PAGE;
    this.searchSize = Constant.SIZE;
    this.filterOption(searchTerm, true);

    // Also run a client-side search over currently-loaded messages so
    // users can see instant results (the server call is paginated).
    const haystack = this.whatsappMessageLogsList || [];
    this.searchResults = haystack.filter((message: any) => {
      const messageText = (message.message || '').toString().toLowerCase();
      const bodyText = (message.bodyText || '').toString().toLowerCase();
      const webHookText = (message.WebHookText || '').toString().toLowerCase();
      const templateText = (this.getTemplateBody(message) || '').toString().toLowerCase();
      const combined = `${messageText} ${bodyText} ${webHookText} ${templateText}`;
      return combined.includes(query);
    });

    this.groupSearchResults();

    this.showSearchPanel = true;

    if (this.searchResults.length > 0) {
      this.currentMatchIndex = 0;
      this.highlightAndScrollToMatch();
    } else {
      this.currentMatchIndex = -1;
      this.highlightedMessageId = null;
    }
  }
  filterOption(event?: any, reset: boolean = false) {
    if (event != null) {
      this.search = event;
    }

    if (reset) {
      this.searchPageNumber = Constant.PAGE || 0;
      this.whatsappMessageLogsList = [];
    }

    this.spinner = true;

    const pageToRequest = this.searchPageNumber;

    this.whatsappMessageLogsServiceNew.searchMessageLogReport(this.search, pageToRequest, this.searchSize, this.sortParam, null).subscribe(
      (res: any) => {
        this.spinner = false;

        // Expecting Page-like response with 'content' and 'last' properties
        const content = res?.content || [];
        if (reset) {
          this.whatsappMessageLogsList = content;
        } else {
          this.whatsappMessageLogsList = [...(this.whatsappMessageLogsList || []), ...content];
        }

        this.elements = res?.numberOfElements ?? content.length;
        this.pageList = res?.totalElements ?? (this.whatsappMessageLogsList || []).length;
        this.pageSizeValue = getPageSize(this.pageList);
        this.searchTotalElements = res?.totalElements ?? this.pageList;

        // Determine if more pages exist. If API provides 'last' flag, use it.
        const isLast = typeof res?.last === 'boolean' ? res.last : (content.length < this.searchSize);
        this.searchHasMore = !isLast;

        // Advance page for next load
        if (!isLast) {
          this.searchPageNumber = pageToRequest + 1;
        }

        // Update client-side instant search results using loaded pages
        const haystack = this.whatsappMessageLogsList || [];
        const q = (this.searchQuery || '').toString().toLowerCase();
        this.searchResults = haystack.filter((message: any) => {
          const messageText = (message.message || '').toString().toLowerCase();
          const bodyText = (message.bodyText || '').toString().toLowerCase();
          const webHookText = (message.WebHookText || '').toString().toLowerCase();
          const templateText = (this.getTemplateBody(message) || '').toString().toLowerCase();
          const combined = `${messageText} ${bodyText} ${webHookText} ${templateText}`;
          return q ? combined.includes(q) : true;
        });

        this.groupSearchResults();

      },
      error => {
        this.spinner = false;

      })

  }

  loadMoreSearchResults(): void {
    if (!this.searchHasMore || this.spinner) { return; }
    // request next page (filterOption will increment page)
    this.filterOption(undefined, false);
  }
  groupSearchResults(): void {
    const groupsMap = new Map<string, any[]>();

    this.searchResults.forEach(message => {
      const date = new Date(message.messagedAt).toLocaleDateString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });

      if (!groupsMap.has(date)) {
        groupsMap.set(date, []);
      }

      groupsMap.get(date)?.push({
        ...message,
        // Store the original message for highlighting
        originalMessage: message.message || this.getTemplateBody(message) || ''
      });
    });

    this.groupedSearchResults = Array.from(groupsMap.entries()).map(([date, messages]) => ({
      date,
      messages
    }));
  }
  async scrollToMessage(message: any): Promise<void> {
    // Normalize identity helpers
    const getKey = (m: any) => (m && m.id) ? String(m.id) : (m && m.uid) ? String(m.uid) : null;

    const targetKey = getKey(message);
    if (!targetKey) return;

    // show search/loading spinner while we attempt to locate/fetch the message
    this.spinner = true;
    try { this.loaderService.show(); } catch (_) { }
    try {
      // 1) If already in log, scroll directly
      const found = this.findMessageInLog(targetKey);
      if (found) {
        this.selectedSearchResultUid = String(found.uid || found.id || targetKey);
        this.highlightedMessageId = String(found.uid || found.id || targetKey);
        await this.scrollAndFlash(found);
        return;
      }

      // 2) Otherwise, load older pages until found or no more pages
      // Guard to prevent infinite loop
      const maxPages = 100;
      let pagesLoaded = 0;

      while (this.hasMoreMessages && pagesLoaded < maxPages) {
        pagesLoaded++;
        try {
          const appended = await this.loadOneOlderPage(); // appends to whatsappMessageLog
          if (!appended) {
            // nothing appended, break to avoid tight loop
            break;
          }

          const foundAfter = this.findMessageInLog(targetKey);
          if (foundAfter) {
            this.selectedSearchResultUid = String(foundAfter.uid || foundAfter.id || targetKey);
            this.highlightedMessageId = String(foundAfter.uid || foundAfter.id || targetKey);
            await this.scrollAndFlash(foundAfter);
            return;
          }
          // Continue loop until hasMoreMessages false or found
        } catch (err) {
          console.error('Error loading older page while searching for message', err);
          break;
        }
      }

      // 3) Fallback: try fetching directly by uid/id endpoint (single-message fetch)
      const fetchKey = message.uid || (message.id ? String(message.id) : null);
      if (fetchKey) {
        try {
          const res: any = await this.whatsappservice.getMessageByUid(fetchKey).toPromise();
          const msgs = Array.isArray(res) ? res : (res?.content || []);
          if (msgs && msgs.length > 0) {
            // Append missing messages (dedupe)
            const existingIds = new Set((this.whatsappMessageLog || []).map((m: any) => getKey(m)));
            const toAdd = msgs.filter((m: any) => !existingIds.has(getKey(m)));
            if (toAdd.length > 0) {
              this.whatsappMessageLog = [...(this.whatsappMessageLog || []), ...toAdd];
              this.cdRef.detectChanges();
            }

            const foundFinal = this.findMessageInLog(getKey(msgs[0]));
            if (foundFinal) {
              this.selectedSearchResultUid = String(foundFinal.uid || foundFinal.id || getKey(foundFinal));
              this.highlightedMessageId = String(foundFinal.uid || foundFinal.id || getKey(foundFinal));
              await this.scrollAndFlash(foundFinal);
              return;
            }
          }
        } catch (err) {
          console.error('Failed fallback getMessageByUid', err);
        }
      }
    }
    catch (err) {
      console.error('scrollToMessage failed', err);
    }
    finally {
      this.spinner = false;
      try { this.loaderService.hide(); } catch (_) { }
    }
  }

  /**
   * Find message in `whatsappMessageLog` by normalized key (prefers id then uid)
   */
  private findMessageInLog(targetKey: string): any | null {
    if (!this.whatsappMessageLog || !this.whatsappMessageLog.length) return null;
    return this.whatsappMessageLog.find((m: any) => {
      const k = (m && m.id) ? String(m.id) : (m && m.uid) ? String(m.uid) : null;
      return k === targetKey;
    }) || null;
  }

  /**
   * Load one older page (next page) and append/prepend processed messages.
   * Returns number of messages appended (0 if none).
   */
  private async loadOneOlderPage(): Promise<number> {
    if (this.isLoadingMoreMsg || !this.selectedContact || !this.selectedContact.id) return 0;
    // Next page index (server expects page numbers starting at 0)
    const nextPage = this.pageMsg + 1;
    this.isLoadingMoreMsg = true;
    try {
      const data: any = await this.whatsappservice.getChatHistoryByContactId(this.selectedContact.id, nextPage, this.size).toPromise();
      const rawMessages: any[] = data?.content || [];
      const isLastPage: boolean = data?.last ?? true;

      if (!rawMessages || rawMessages.length === 0) {
        this.hasMoreMessages = false;
        this.isLoadingMoreMsg = false;
        return 0;
      }

      // API returns DESC order — reverse so oldest appears at top when prepended
      const newMessages = [...rawMessages].reverse();

      // Process each message (reuse same parsing pipeline as loadOlderMessages)
      const processed = newMessages.map(msg => {
        if (msg.data) {
          try {
            const parsed = JSON.parse(msg.data);
            if (parsed.interaction_message_data) {
              const interactiveData = parsed.interaction_message_data;
              msg.interactiveType = interactiveData.interactive_type;
              msg.interactiveData = {
                headerType: interactiveData.header_type,
                mediaLink: interactiveData.media_link,
                bodyText: interactiveData.body_text,
                footerText: interactiveData.footer_text,
                headerText: interactiveData.header_text,
                buttons: interactiveData.buttons,
                listData: interactiveData.list_data,
                ctaData: interactiveData.cta_url
              };
              if (interactiveData.header_type && ['image', 'video', 'audio', 'document'].includes(interactiveData.header_type)) {
                msg.media = { mediaUrl: interactiveData.media_link, extension: this.getFileExtension(interactiveData.media_link) };
              }
              switch (msg.interactiveType) {
                case 'button':
                  msg.buttonData = { buttons: interactiveData.buttons, bodyText: interactiveData.body_text, footerText: interactiveData.footer_text, headerText: interactiveData.header_text, headerType: interactiveData.header_type, mediaLink: interactiveData.media_link };
                  break;
                case 'list':
                  msg.listData = { buttonText: interactiveData.list_data?.button_text, sections: this.parseSections(interactiveData.list_data?.sections), bodyText: interactiveData.body_text, footerText: interactiveData.footer_text, headerText: interactiveData.header_text };
                  break;
                case 'cta_url':
                  msg.ctaData = { displayText: interactiveData.cta_url?.display_text, url: interactiveData.cta_url?.url, bodyText: interactiveData.body_text, footerText: interactiveData.footer_text, headerText: interactiveData.header_text };
                  break;
              }
            }

            if (parsed.template_proforma) {
              const template = parsed.template_proforma;
              const components = template.components || [];
              msg.templateComponents = {};
              components.forEach((comp: any) => {
                switch (comp.type) {
                  case 'HEADER': msg.templateComponents.header = { type: comp.format?.toLowerCase() || 'text', text: comp.text || '', example: comp.example?.header_handle?.[0] || '' }; break;
                  case 'BODY': msg.templateComponents.body = comp.text || ''; break;
                  case 'FOOTER': msg.templateComponents.footer = comp.text || ''; break;
                  case 'BUTTONS': msg.templateComponents.buttons = comp.buttons || []; break;
                }
              });
              if (parsed.template_components) {
                parsed.template_components.forEach((comp: any) => {
                  switch (comp.type) {
                    case 'HEADER': msg.templateComponents.header = { type: comp.format?.toLowerCase() || 'text', text: comp.text || '', example: comp.example?.header_handle?.[0] || '', url: msg.templateComponents.header?.url || '' }; break;
                    case 'BODY': msg.templateComponents.body = comp.text || ''; break;
                    case 'FOOTER': msg.templateComponents.footer = comp.text || ''; break;
                    case 'BUTTONS': msg.templateComponents.buttons = comp.buttons || []; break;
                  }
                });
              }
              if (parsed.template_component_values) {
                parsed.template_component_values.forEach((compVal: any) => {
                  if (compVal.type === 'header' && compVal.parameters?.length) {
                    const param = compVal.parameters[0];
                    if (param.type === 'location') {
                      msg.templateComponents.location = { name: param.location?.name || '', address: param.location?.address || '', latitude: param.location?.latitude || '', longitude: param.location?.longitude || '' };
                    }
                    if (msg.templateComponents.header) {
                      const link = param.image?.link || param.video?.link || param.document?.link;
                      if (link) {
                        const urlObj = new URL(link);
                        urlObj.searchParams.delete('cid');
                        msg.templateComponents.header.url = decodeURIComponent(urlObj.toString());
                      } else if (param.text) {
                        msg.templateComponents.header.text = param.text;
                      }
                    }
                  }
                  if (compVal.type === 'body' && compVal.parameters?.length) {
                    msg.templateComponents = msg.templateComponents || {};
                    parsed.template_components?.forEach((comp: any) => {
                      if (comp.type === 'BODY' && comp.text) {
                        let bodyText = comp.text.replace(/&#123;/g, '{').replace(/&#125;/g, '}');
                        const bodyCompVal = parsed.template_component_values?.find((v: any) => v.type?.toLowerCase() === 'body');
                        if (bodyCompVal?.parameters?.length) {
                          bodyCompVal.parameters.forEach((p: any, i: number) => {
                            if (p.type === 'text' && p.text) { bodyText = bodyText.replace(new RegExp(`{{\\s*${i + 1}\\s*}}`, 'g'), p.text.trim()); }
                          });
                        }
                        msg.templateComponents.body = bodyText;
                      }
                    });
                  }
                });
              }
            }

            if (parsed.webhook_responses && msg?.message === '' && !msg?.interactiveType?.length) {
              try { const webHookText = parsed.webhook_responses.incoming[0].changes[0].value.messages[0].text.body; msg.WebHookText = webHookText; } catch (_) { }
            }

            const media = parsed.media_values;
            if (media?.link && (media?.type || media?.mime_type)) {
              let type = media.type;
              if ((type === 'document' || !type) && media.mime_type) {
                const mimeMain = media.mime_type.split('/')[0];
                if (['image', 'video', 'audio'].includes(mimeMain)) { type = mimeMain; }
              }
              msg.mediaData = { type, url: media.link.trim(), caption: media.caption || '', mimeType: media.mime_type || '' };
              const extMatch = media.link.match(/\.([a-zA-Z0-9]+)(?=[?#]|$)/);
              msg.mediaData.extension = extMatch ? extMatch[1].toLowerCase() : '';
            } else { msg.mediaData = null; }
          } catch (e) { console.error('Error parsing older message data', e); }
        }
        return msg;
      });

      // Deduplicate against already-displayed messages
      const existingIds = new Set((this.whatsappMessageLog || []).map((m: any) => (m.uid || String(m.id))));
      const toAdd = processed.filter((m: any) => !existingIds.has(m.uid || String(m.id)));

      if (toAdd.length > 0) {
        // Prepend older messages
        this.whatsappMessageLog = [...toAdd, ...(this.whatsappMessageLog || [])];
        this.pageMsg = nextPage;
      }

      if (isLastPage) { this.hasMoreMessages = false; }

      this.isLoadingMoreMsg = false;
      return toAdd.length;
    } catch (err) {
      this.isLoadingMoreMsg = false;
      console.error('Error loading older messages page', err);
      throw err;
    }
  }

  /** Scroll to element and flash highlight (center, animate, keep message highlight) */
  private async scrollAndFlash(msg: any): Promise<void> {
    const uid = String(msg.uid || msg.id || '');
    this.highlightedMessageId = uid;
    this.cdRef.detectChanges();

    // Try to locate DOM element; if not present, wait a moment for render
    let el = document.getElementById(`message-${msg.uid || msg.id}`) || document.getElementById(`message-${uid}`);
    if (!el) {
      await new Promise(resolve => setTimeout(resolve, 60));
      el = document.getElementById(`message-${msg.uid || msg.id}`) || document.getElementById(`message-${uid}`);
    }
    if (!el) return;

    try {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch (_) { /* ignore */ }

    // add temporary animation class
    el.classList.add('highlight-animate');
    setTimeout(() => { el.classList.remove('highlight-animate'); }, 1200);
    // keep message highlighted for a longer period (e.g., 5s)
    setTimeout(() => { if (this.highlightedMessageId === uid) { this.highlightedMessageId = null; } }, 5000);
  }
  toggleSearchPanel() {
    this.searchQuery = ''; // Clear search when toggling
    this.showSearchPanel = !this.showSearchPanel;
  }

  clearSearch(): void {
    this.searchQuery = '';
    this.searchResults = [];
    this.groupedSearchResults = [];
    this.currentMatchIndex = -1;
    this.highlightedMessageId = null;
    this.selectedSearchResultUid = null;
    this.showSearchPanel = false;
  }

  navigateSearch(direction: number): void {
    if (this.searchResults.length === 0) return;

    this.currentMatchIndex += direction;

    // Circular navigation
    if (this.currentMatchIndex < 0) {
      this.currentMatchIndex = this.searchResults.length - 1;
    } else if (this.currentMatchIndex >= this.searchResults.length) {
      this.currentMatchIndex = 0;
    }

    this.highlightAndScrollToMatch();
  }

  highlightAndScrollToMatch(): void {
    if (this.currentMatchIndex < 0 || this.currentMatchIndex >= this.searchResults.length) return;

    const message = this.searchResults[this.currentMatchIndex];
    this.highlightedMessageId = message.uid;
    // console.log("the current highlight is is",this.highlightedMessageId);


    setTimeout(() => {
      const element = document.getElementById(`message-${message.uid}`);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });

        element.classList.add('highlight-animate');
        setTimeout(() => {
          element.classList.remove('highlight-animate');
        }, 1000);
        // keep message highlighted for a longer period (e.g., 5s)
        setTimeout(() => { if (this.highlightedMessageId === message.uid) { this.highlightedMessageId = null; } }, 5000);
      }
    }, 0);
  }

  isMessageHighlighted(messageUid: string): boolean {
    return this.highlightedMessageId === messageUid;
  }

  getHighlightedText(text: string | null): string {
    if (!this.searchQuery || !text) return text || '';

    // Escape special regex characters
    const escapedQuery = this.searchQuery.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(escapedQuery, 'gi');
    console.log(text.replace(regex, match => `<span class="highlight">${match}</span>`));

    return text.replace(regex, match => `<span class="highlight">${match}</span>`);
  }

  // loadContacts() {
  //   this.whatsappservice.getContacts().subscribe((contacts: any[]) => {
  //     this.originalContacts = contacts;
  //     this.filteredContacts = [...contacts];
  //   });
  // }

  onSearchContacts() {
    if (!this.searchQueryTwo) {
      this.filteredContacts = [...this.contacts];
      return;
    }

    const query = this.searchQueryTwo.toLowerCase();
    this.filteredContacts = this.contacts.filter(contact => {
      const firstNameMatch = contact.firstName?.toLowerCase().includes(query);
      const lastNameMatch = contact.lastName?.toLowerCase().includes(query);
      const phoneMatch = contact.phone?.toLowerCase().includes(query);
      return firstNameMatch || lastNameMatch || phoneMatch;
    });
  }

  clearContactSearch() {
    this.searchQueryTwo = '';
    this.searchTermMain = '';
    this.searchTermMainPresent = true;

    this.contacts = [];
    this.filteredContacts = [];
    this.allContactsLoaded = false;
    this.currentPage = 0;

    // Force reload of contacts
    if (this.whatsappContactId !== undefined && this.whatsappVendorId !== undefined) {
      this.getResource();
    }
  }
  getHighlightedContactName(contact: any): string {
    if (!this.searchTermMain) {
      return `${contact.firstName || ''} ${contact.lastName || ''}`.trim();
    }

    const query = this.searchTermMain.toLowerCase();
    let firstName = contact.firstName || '';
    let lastName = contact.lastName || '';

    if (firstName.toLowerCase().includes(query)) {
      const regex = new RegExp(query, 'gi');
      firstName = firstName.replace(regex, match => `<span class="highlight-contact">${match}</span>`);
    }
    if (lastName.toLowerCase().includes(query)) {
      const regex = new RegExp(query, 'gi');
      lastName = lastName.replace(regex, match => `<span class="highlight-contact">${match}</span>`);
    }

    return `${firstName} ${lastName}`.trim();
  }
  clearChat() {
    // if (!this.selectedContact) return;

    // // Confirm before clearing
    // if (confirm('Are you sure you want to clear this chat?')) {
    //   this.whatsappservice.clearChat(this.selectedContact.uid).subscribe({
    //     next: () => {
    //       this.whatsappMessageLog = [];
    //       console.log('Chat cleared successfully');
    //     },
    //     error: (err) => {
    //       console.error('Error clearing chat:', err);
    //     }
    //   });
    // }
  }

  toggleFavorite() {
    // if (!this.selectedContact) return;

    // this.isFavorite = !this.isFavorite;
    // this.whatsappservice.toggleFavorite(this.selectedContact.uid, this.isFavorite).subscribe({
    //   next: () => {
    //     console.log('Favorite status updated');
    //   },
    //   error: (err) => {
    //     console.error('Error updating favorite status:', err);
    //     this.isFavorite = !this.isFavorite; // Revert on error
    //   }
    // });
  }

  closeChat() {
    this.selectedContact = null;
    this.selectedContactUid = null;
    this.whatsappMessageLog = [];
    this.resetTextArea();
    // Remove any contact query param so the UI does not reopen the chat
    try {
      this.router.navigate([], { relativeTo: this.route, queryParams: {} });
    } catch (err) {
      // fallback: replace browser path
      try { this.location.replaceState('/whatsAppChat'); } catch (_) { }
    }
    try { this.cdRef.detectChanges(); } catch (_) { }
  }
  goBack() {
    this.selectedContact = null;
    this.selectedContactUid = null;
    this.whatsappMessageLog = [];
    this.resetTextArea();
    try {
      this.router.navigate([], { relativeTo: this.route, queryParams: {} });
    } catch (err) {
      try { this.location.replaceState('/whatsAppChat'); } catch (_) { }
    }
    let str = 'false';
    localStorage.setItem('HideMainMenu', str);
    try { this.cdRef.detectChanges(); } catch (_) { }
  }

  processRawMessages(rawMessages: any[]): any[] {
    return rawMessages.map(msg => {
      if (msg.data) {
        try {
          const parsed = JSON.parse(msg.data);
          // Interactive messages
          if (parsed.interaction_message_data) {
            const interactiveData = parsed.interaction_message_data;
            msg.interactiveType = interactiveData.interactive_type;
            msg.interactiveData = {
              headerType: interactiveData.header_type,
              mediaLink: interactiveData.media_link,
              bodyText: interactiveData.body_text,
              footerText: interactiveData.footer_text,
              headerText: interactiveData.header_text,
              buttons: interactiveData.buttons,
              listData: interactiveData.list_data,
              ctaData: interactiveData.cta_url
            };
            if (interactiveData.header_type && ['image', 'video', 'audio', 'document'].includes(interactiveData.header_type)) {
              msg.media = {
                mediaUrl: interactiveData.media_link,
                extension: this.getFileExtension(interactiveData.media_link)
              };
            }
          }
          // Template messages
          if (parsed.template_proforma) {
            const template = parsed.template_proforma;
            const components = template.components || [];
            msg.templateComponents = {};
            components.forEach((comp: any) => {
              switch (comp.type) {
                case 'HEADER': msg.templateComponents.header = { type: comp.format?.toLowerCase() || 'text', text: comp.text || '', example: comp.example?.header_handle?.[0] || '' }; break;
                case 'BODY': msg.templateComponents.body = comp.text || ''; break;
                case 'FOOTER': msg.templateComponents.footer = comp.text || ''; break;
                case 'BUTTONS': msg.templateComponents.buttons = comp.buttons || []; break;
              }
            });
            if (parsed.template_components) {
              parsed.template_components.forEach((comp: any) => {
                switch (comp.type) {
                  case 'HEADER': msg.templateComponents.header = { type: comp.format?.toLowerCase() || 'text', text: comp.text || '', example: comp.example?.header_handle?.[0] || '', url: msg.templateComponents.header?.url || '' }; break;
                  case 'BODY': msg.templateComponents.body = comp.text || ''; break;
                  case 'FOOTER': msg.templateComponents.footer = comp.text || ''; break;
                  case 'BUTTONS': msg.templateComponents.buttons = comp.buttons || []; break;
                }
              });
            }
            if (parsed.template_component_values) {
              parsed.template_component_values.forEach((compVal: any) => {
                if (compVal.type === 'header' && compVal.parameters?.length) {
                  const param = compVal.parameters[0];
                  const link = param.image?.link || param.video?.link || param.document?.link;
                  if (link && msg.templateComponents.header) {
                    try {
                      const urlObj = new URL(link);
                      urlObj.searchParams.delete('cid');
                      msg.templateComponents.header.url = decodeURIComponent(urlObj.toString());
                    } catch (_) { msg.templateComponents.header.url = link; }
                  }
                }
              });
            }
          }
          // Media
          const media = parsed.media_values;
          let mediaUrl = media?.link;
          let mediaType = media?.type;
          let mediaMimeType = media?.mime_type;
          let mediaCaption = media?.caption || '';
          let mediaFilename = media?.file_name || '';

          if (!mediaUrl && parsed.webhook_responses?.incoming?.[0]?.changes?.[0]?.value?.messages?.[0]) {
            const whMsg = parsed.webhook_responses.incoming[0].changes[0].value.messages[0];
            const whType = whMsg.type;
            if (whType && whMsg[whType]) {
              mediaUrl = whMsg[whType].url;
              mediaType = whType;
              mediaMimeType = whMsg[whType].mime_type;
              mediaCaption = whMsg[whType].caption || '';
              mediaFilename = whMsg[whType].filename || '';
            }
          }

          if (mediaUrl && (mediaType || mediaMimeType)) {
            let type = mediaType;
            if ((type === 'document' || !type) && mediaMimeType) {
              const mimeMain = mediaMimeType.split('/')[0];
              if (['image', 'video', 'audio'].includes(mimeMain)) { type = mimeMain; }
            }
            msg.mediaData = { type, url: mediaUrl.trim(), caption: mediaCaption || '', mimeType: mediaMimeType || '' };
            let extMatch = (mediaFilename || '').match(/\.([a-zA-Z0-9]+)(?=[?#]|$)/);
            if (!extMatch) {
              extMatch = mediaUrl.match(/\.([a-zA-Z0-9]+)(?=[?#]|$)/);
            }
            msg.mediaData.extension = extMatch ? extMatch[1].toLowerCase() : '';
            if (!msg.mediaData.extension && mediaMimeType) {
              const parts = mediaMimeType.split('/');
              if (parts.length > 1) {
                let ext = parts[1].toLowerCase();
                if (ext === 'plain') ext = 'txt';
                if (ext === 'mpeg') ext = 'mp3';
                msg.mediaData.extension = ext;
              }
            }
          } else { msg.mediaData = null; }
        } catch (e) {
          console.error('Error parsing message data', e);
        }
      }
      return msg;
    });
  }

  openMedia(msg: any) {
    const getUrl = (url: string) => {
      if (!url) return '';
      const separator = url.includes('?') ? '&' : '?';
      const cidValue = this.cid ? this.cid.replace(/[&?]/, '').replace('cid=', '') : '';
      return url + separator + 'cid=' + cidValue;
    };

    if (msg.mediaData) {
      if (msg.mediaData.type === 'video' || msg.mediaData.type === 'image') {
        this.openImage(getUrl(msg.mediaData.url));
      }
    } else if (msg.templateComponents?.header) {
      if (msg.templateComponents.header.type === 'image' || msg.templateComponents.header.type === 'video') {
        this.openImage(getUrl(msg.templateComponents.header.url));
      }
    } else if (msg.interactiveData) {
      if (msg.interactiveData.headerType === 'image' || msg.interactiveData.headerType === 'video') {
        this.openImage(getUrl(msg.media?.mediaUrl || msg.interactiveData.mediaLink));
      }
    }
  }


  // deleteChat(value) {

  //   this.whatsappBlockService.deleteByContactWaId(value.waId)
  //     .pipe(take(1))
  //     .subscribe(
  //     (res) => {

  //       console.log("res", res);

  //      this.getAllWhatssappChat();

  //     },
  //     (err) => {

  //     });

  // }

  deleteChat(value) {
    this.whatsappBlockService.deleteByContactWaId(value.waId)
      .pipe(take(1))
      .subscribe(() => {

        this.currentPage = 0;
        this.contacts = [];
        this.filteredContacts = [];
        this.selectedContact = null;
        this.selectedContactUid = null;

        this.getAllWhatssappChat();
      });
  }

  blockChat(value) {

    console.log("value", value);

    let object = {
      "users": [value.waId],
    }

    this.whatsappBlockService.blockNumber(object)
      .pipe(take(1))
      .subscribe(
        (res) => {

          console.log("res", res);
          this.isBlocked = 1;
          this.snackBar.open('Contact Blocked!', 'Close', {
            duration: 3000,
            verticalPosition: 'bottom',
            panelClass: 'success'
          });
          this.getAllWhatssappChat();
          if (this.selectedContact?.uid) {
            this.loadChatMessages(this.selectedContact.uid);
          }


        },
        (err) => {

        });

  }


  unblockChat(value) {

    let object = {
      "users": [value.waId ?? value.wa_id],
    }

    this.whatsappBlockService.UnblockNumber(object)
      .pipe(take(1))
      .subscribe(
        (res) => {
          this.snackBar.open('Contact unblocked!', 'Close', {
            duration: 3000,
            verticalPosition: 'bottom',
            panelClass: 'success'
          });
          this.dialog.closeAll();

          this.getAllBlockList();
          this.isBlocked = 0;
          if (this.selectedContact?.uid) {
            this.loadChatMessages(this.selectedContact.uid);
          }
        },
        (err) => {

        });

  }

  formatDateNew(time: string): string {
    if (!time) return ''; // Safeguard against null/undefined

    // Convert to ISO 8601 format
    const isoTime = time.replace(' ', 'T') + 'Z';

    const date = new Date(isoTime);

    if (isNaN(date.getTime())) {
      console.error('Invalid date:', isoTime);
      return 'Invalid date';
    }

    const options: Intl.DateTimeFormatOptions = {
      timeZone: 'Asia/Kolkata',
      hour12: true,
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    };

    return new Intl.DateTimeFormat('en-GB', options).format(date);
  }

  //FOR media type check
  isMediaLabel(message: string): boolean {
    return message?.startsWith('media-');
  }

  //FOR media icon 
  getMediaMatIcon(label: string): string {
    switch (label) {
      case 'media-image': return 'image';
      case 'media-video': return 'videocam';
      case 'media-audio': return 'audiotrack';
      case 'media-document': return 'description';
      default: return 'insert_drive_file';
    }
  }

  //FOR media Label 
  getMediaLabelText(label: string): string {
    switch (label) {
      case 'media-image': return 'Image';
      case 'media-video': return 'Video';
      case 'media-audio': return 'Audio';
      case 'media-document': return 'Document';
      default: return 'Media';
    }
  }
  getDocumentIcon(extension: string): string {
    if (!extension) return 'insert_drive_file';

    const ext = extension.toLowerCase();

    if (ext === 'pdf') return 'picture_as_pdf';
    if (['xls', 'xlsx'].includes(ext)) return 'grid_on'; // or 'table_chart'
    if (['doc', 'docx'].includes(ext)) return 'description';
    if (['ppt', 'pptx'].includes(ext)) return 'slideshow';
    if (['txt', 'text'].includes(ext)) return 'notes';

    return 'insert_drive_file'; // fallback icon
  }

  @ViewChild('unblock') unblock: TemplateRef<any>;

  unblockPopup() {
    this.getAllBlockList();
    let dialogRef = this.dialog.open(this.unblock, {
      width: '350px',
      disableClose: true,
    });
    dialogRef.disableClose = true;
  }

  blockedContact: any;

  getAllBlockList() {
    this.whatsappBlockService.getUnblockList()
      .pipe(take(1))
      .subscribe(res => {

        console.log("res", res);

        this.blockedContact = res['data'];

        console.log("blockedContact", this.blockedContact);


      },
        error => {

        })
  }

  AssignedUser() {
    const dialogRef = this.dialog.open(WhatsAppAssigneUserComponent, {
      width: '400px',
      disableClose: true,
      data: {
        contactUid: this.selectedContact?.uid,
        assignedUsersId: this.selectedContact?.assignedUsersId
      }
    });

    dialogRef.afterClosed()
      .pipe(take(1))
      .subscribe(result => {
        console.log('Dummy popup closed');
      });
  }

  firstFormGroup: UntypedFormGroup;

  createWhatsAppForm() {
    this.firstFormGroup = this._formBuilder.group({
      id: [''],
      contactUid: [''],
      status: [''],
      updatedAt: [''],
      createdAt: [''],
      firstName: [''],
      lastName: [''],
      countriesId: [''],
      whatsappOptOut: [''],
      phoneVerifiedAt: [''],
      email: [''],
      emailVerifiedAt: [''],
      vendorId: [''],
      waId: [''],
      languageCode: [''],
      disableAiBot: [''],
      data: [''],
      assignedUsersId: [''],
      isDeleted: [''],
    })
  }
  locations: any = "calsoftgroup.com";
  type: any = "whatsapp";

  public bannerServerPath = environment.commonImageApi + '/whatsapp/';

  handleUploadedFile(result: any) {
    let fileName = result.fileName;
    let caption = result.caption;
    if (!result || !result.fileName) {
      this.snackBar.open('Please upload the media', 'Close', {
        duration: 3000,
        panelClass: ['error']
      });
      return;
    }

    this.loaderService.show();
    const cid = localStorage.getItem(Constant.enterPriseKey);
    const fullPath = `${this.bannerServerPath}${fileName}&cid=${cid}`;
    const extension = fileName.split('.').pop()?.toLowerCase() || '';
    let mediaType: 'audio' | 'video' | 'image' | 'document' = 'document';

    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
    const videoExtensions = ['mp4', 'mov', 'avi', 'webm', 'mkv'];
    const audioExtensions = ['mp3', 'wav', 'ogg', 'm4a'];
    const documentExtensions = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt', 'csv'];

    if (imageExtensions.includes(extension)) {
      mediaType = 'image';
    } else if (videoExtensions.includes(extension)) {
      mediaType = 'video';
    } else if (audioExtensions.includes(extension)) {
      mediaType = 'audio';
    } else if (documentExtensions.includes(extension)) {
      mediaType = 'document';
    }

    const jsondata = {
      contactUid: this.selectedContact.uid,
      filepond: "undefined",
      uploadedMediaFileName: fileName,
      mediaType,
      mediaUrl: fullPath,
      caption: caption || ""
    };


    this.whatsappservice.sendMediaChat(jsondata)
      .pipe(take(1))
      .subscribe({
        next: (res) => {

          this.loaderService.hide();
          this.getAllWhatssappChat();
          if (this.selectedContact?.uid) {
            this.loadChatMessages(this.selectedContact.uid);
          }
          console.log('Media sent successfully:', res);
        },
        error: (err) => {
          this.loaderService.hide();
          console.error('Error sending media:', err);
        }
      });
  }


  getFiles(): FileLikeObject[] {
    return this.uploader.queue.map((fileItem) => fileItem.file);
  }

  openImage(src: string): void {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(ImageZoomComponent, {
        width: '900px',
        height: '550px',
        data: { data: src }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed()
        .pipe(take(1))
        .subscribe(result => {


        });

    }
    else {
      let dialogRef = this.dialog.open(ImageZoomComponent, {
        minWidth: '100vw', height: '100vh',
        data: { data: src }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed()
        .pipe(take(1))
        .subscribe(result => {

        });
    }
  }



  downloadImage(path: string) {
    console.log(path);
    this.downloadImageService.downloadMediaByUrl(path);
  }

  addEmoji(event: any) {
    console.log('Emoji selected:', event.emoji.native);

    // Get current cursor position
    const textarea = this.msgInput.nativeElement;
    const cursorPosition = textarea.selectionStart;

    // Insert emoji at cursor position
    const textBefore = this.messageText.substring(0, cursorPosition);
    const textAfter = this.messageText.substring(cursorPosition);
    this.messageText = textBefore + event.emoji.native + textAfter;

    // // Close picker if not pinned
    // if (!this.stayOpen) {
    //   setTimeout(() => {
    //     this.hideEmojiPicker();
    //   }, 100);
    // }

    // Focus back on textarea and set cursor position
    setTimeout(() => {
      textarea.focus();
      const newPosition = cursorPosition + event.emoji.native.length;
      textarea.setSelectionRange(newPosition, newPosition);

      // Adjust height after adding emoji
      this.adjustTextAreaHeight(textarea);
    }, 50);
  }

  toggleEmojiPicker(event: Event) {
    event.stopPropagation();
    this.showEmojiPicker = !this.showEmojiPicker;
  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    if (!this.showEmojiPicker) return;

    const target = event.target as HTMLElement;
    if (!target.closest('emoji-mart') && !target.closest('.emoji-picker-container') && !target.closest('.emoji-btn')) {
      this.showEmojiPicker = false;
    }
  }

  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

  protected _onDestroy = new Subject<void>();
}
